<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <el-menu :default-active="idx" class="el-menu-demo" mode="horizontal">
                <el-menu-item index="0" @click="$router.push('live')">智慧住建</el-menu-item>
                <el-menu-item index="1" @click="$router.push('site')">智慧工地</el-menu-item>
                <el-menu-item index="2" @click="$router.push('schemeSafety')">智慧安全</el-menu-item>
                <el-menu-item index="3" @click="$router.push('schemeCartoon')">工程动画</el-menu-item>
                <el-menu-item index="4" @click="$router.push('schemeShowRoom')">项目展厅展馆</el-menu-item>
            </el-menu>
        </div>
        <div class="box3">
            <div class="main" v-for="item in dataList" :key="item.id" @click="siteClick(item.id)">
                <img class="lef" :src="item.img">
                <div>
                    <p class="tit">{{ item.title }}</p>
                    <p class="txt">{{ item.text }}</p>
                </div>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Site",
    data() {
        return {
            idx: '1',
            dataList: [
                {
                    id: 0,
                    img: require('./img/site/company/1.png'),
                    title: '企业集团级智慧工地云平台',
                    text: '企业集团级智慧工地云平台采用大数据分析与挖掘AI人工智能、云计算等物联网技术集成人员数据、硬件设备数据、项目管理业务流程数据等让公司高层管理者迅速获得全公司所有项目的各种数据为分析、决策保驾护航，降本增效...'
                },
                {
                    id: 1,
                    img: require('./img/site/project/1.png'),
                    title: '项目级智慧工地云平台',
                    text: '利用BIM、物联网、大数据和云平台等信息技术，我们将工程信息化、自动化应用高度集成，通过同一个窗口将工程信息集中展现给您，让您不论身在何方，都对项目状态了如指掌...'
                },
            ]
        }
    },
    methods: {
        siteClick(id) {
            this.$router.push({
                path: 'schemeSiteDetail', query: {
                    index: id
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    height: 2.9rem;
    width: 100%;
    background: url("./img/banner/1.jpg");
    background-size: 100% 100%;
}

.box2 {
    width: 10rem;
    margin: .34rem auto .6rem;
    text-align: center;

    a {
        text-decoration: none;
    }

    .el-menu-item {
        width: 2rem;
        font-size: .2rem;
        height: .72rem;
        line-height: .72rem;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: 3px solid #E70F20;
        color: #E70F20;
    }

    .el-menu--horizontal > .el-menu-item {
        color: #000;
    }
}

.box3 {
    width: 12rem;
    margin: 0 auto;

    .main {
        cursor: pointer;
        height: 2.2rem;
        background: #FBFBFB;
        display: flex;
        position: relative;
        margin-bottom: .3rem;

        img.lef {
            width: 3.6rem;
            height: 2.2rem;
        }

        div {
            height: 1.6rem;
            margin: .3rem 0 0 .57rem;

            p.tit {
                font-size: .26rem;
            }

            p.txt {
                width: 6.5rem;
                font-size: .18rem;
                color: #595757;
                line-height: .36rem;
                text-align: justify;
                margin-top: .23rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }

        span {
            position: absolute;
            width: .38rem;
            height: .38rem;
            background: url("../../assets/images/more.png");
            background-size: 100% 100%;
            right: .32rem;
            bottom: .35rem;
            cursor: pointer;
        }
    }
}
</style>
